import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useT } from "../../contexts/LanguageContext";
import { TwitterLogo, LinkedinLogo, InstagramLogo, YoutubeLogo, FacebookLogo, GithubLogo } from "@phosphor-icons/react";

const ICONS = { twitter: TwitterLogo, linkedin: LinkedinLogo, instagram: InstagramLogo, youtube: YoutubeLogo, facebook: FacebookLogo, github: GithubLogo };

export default function Footer() {
  const { t } = useT();
  const [socials, setSocials] = useState({});

  useEffect(() => {
    api.get("/content/social_links")
      .then(({ data }) => setSocials(data?.data || {}))
      .catch(() => {});
  }, []);

  return (
    <footer className="border-t border-slate-200 bg-slate-50/50 mt-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-2 md:grid-cols-4 gap-6">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-2" data-testid="footer-brand">
            <div className="h-7 w-7 rounded-sm bg-[#002FA7] grid place-items-center text-white font-display font-bold">P</div>
            <span className="font-display text-lg font-bold tracking-tight">PMCoach AI</span>
          </Link>
          <p className="text-xs text-slate-500 mt-3 leading-relaxed">{t("footer.tagline")}</p>
          <div className="flex items-center gap-3 mt-4" data-testid="social-links">
            {Object.entries(ICONS).map(([k, Icon]) => {
              const url = socials[k];
              if (!url) return null;
              return (
                <a key={k} href={url} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-[#002FA7] transition-colors" data-testid={`social-${k}`} aria-label={k}>
                  <Icon size={18} weight="bold" />
                </a>
              );
            })}
          </div>
        </div>
        <div>
          <div className="overline">{t("footer.product")}</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li><Link to="/" className="hover:text-[#002FA7]">{t("nav.home")}</Link></li>
            <li><Link to="/pricing" className="hover:text-[#002FA7]" onClick={(e) => { e.preventDefault(); window.location.href = "/#pricing"; }}>{t("landing.pricing.overline")}</Link></li>
            <li><Link to="/faq" className="hover:text-[#002FA7]" data-testid="footer-faq">{t("nav.faq")}</Link></li>
            <li><Link to="/blog" className="hover:text-[#002FA7]" data-testid="footer-blog">Blog</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline">{t("footer.company")}</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li><Link to="/about" className="hover:text-[#002FA7]" data-testid="footer-about">{t("nav.about")}</Link></li>
            <li><Link to="/contact" className="hover:text-[#002FA7]" data-testid="footer-contact">{t("nav.contact")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline">{t("footer.legal")}</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li><Link to="/terms" className="hover:text-[#002FA7]" data-testid="footer-terms">{t("nav.terms")}</Link></li>
            <li><Link to="/distance-sales" className="hover:text-[#002FA7]" data-testid="footer-distance-sales">{t("nav.distance_sales")}</Link></li>
            <li><Link to="/refund" className="hover:text-[#002FA7]" data-testid="footer-refund">{t("nav.refund")}</Link></li>
            <li><Link to="/privacy" className="hover:text-[#002FA7]" data-testid="footer-privacy">{t("nav.privacy")}</Link></li>
            <li><Link to="/kvkk" className="hover:text-[#002FA7]" data-testid="footer-kvkk">{t("nav.kvkk")}</Link></li>
            <li><Link to="/cookies" className="hover:text-[#002FA7]" data-testid="footer-cookies">{t("nav.cookies")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-xs text-slate-500 text-center">
          © {new Date().getFullYear()} PMCoach AI. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
